import Moment from "moment";
import { ClaioSchemaExecuteResult, ClaioSchemaExecuteRequest } from "../../../../domain/localhost/items";
import { IClaioSchemaExecuteResultBean, IClaioSchemaExecuteRequestBean } from "../beans";
import { Sex } from "../../../../domain/patient";
import { IDocumentImageSource, ImageSourceKinds } from "../../../../domain/document";
import { ImageSource } from "../../../../infrastructure/document/ver2";

export class ClaioSchemaParameterTranslator {
  static toClaioSchemaExecuteResult(bean: IClaioSchemaExecuteResultBean, getToken: () => string): ClaioSchemaExecuteResult {
    if (!bean) { return null; }
    const result = new ClaioSchemaExecuteResult();
    result.isComplete = bean.isComplete;
    result.imageSource = this.createImageSource(bean.cacheGuid, getToken);
    result.drawLayerImageSource = null;
    result.drawObjectData = null;
    return result;
  }

  static toCNoteSchemaExecuteResult(bean: IClaioSchemaExecuteResultBean, getToken: () => string): ClaioSchemaExecuteResult {
    if (!bean) { return null; }
    const result = new ClaioSchemaExecuteResult();
    result.isComplete = bean.isComplete;
    result.imageSource = this.createImageSource(bean.cacheGuid, getToken);
    result.drawLayerImageSource = this.createImageSource(bean.drawLayerImageGuid, getToken);
    result.drawObjectData = bean.drawObjectData;
    return result;
  }

  private static createImageSource(cacheGuid: string, getToken: () => string): IDocumentImageSource {
    if (!cacheGuid || cacheGuid === "") {
      // キャンセル判定されるのでオブジェクトには格納されない
      return null;
    }
    return new ImageSource(getToken, null, null, ImageSourceKinds.Cache, cacheGuid);
  }

  static toClaioSchemaExecuteRequestBean(request: ClaioSchemaExecuteRequest): IClaioSchemaExecuteRequestBean {
    if (!request) { return null; }
    if (!(request instanceof ClaioSchemaExecuteRequest)) { throw new Error("invalid request!!!"); }
    const patientBirthDate = Moment(request.patient.birthday);
    return {
      userId: request.user.id,
      userName: request.user.name,
      patientId: request.patient.id,
      patientName: request.patient.name,
      patientKanaName: request.patient.kanaName,
      patientBirth: patientBirthDate.format("YYYY/MM/DD"),
      patientSex: this.toPatientSexText(request.patient.sex),
      originalImageSourceUrl: request.originalImageSourceUrl,
      currentImageSourceUrl: request.currentImageSourceUrl,
      drawLayerImageSourceUrl: request.drawLayerImageSourceUrl,
      drawObjectData: request.drawObjectData,
      departmentId: request.department ? request.department.id : null,
    };
  }

  private static toPatientSexText(sex: Sex): string {
    if (sex === Sex.Male) { return "M"; }
    if (sex === Sex.Female) { return "F"; }
    return "O";
  }
}
